import _ from 'lodash';
import * as storage from './storage';
import { tripStartCountdown } from './bookingDetailsHelper';

// redirect checker
export const checkAndPerformRedirect = (pathname) => {
    if (!window.$content?.redirectPages || !pathname) {
        return null;
    }

    const redirectConfig = _.find(window.$content.redirectPages, pathname);
    if (!redirectConfig) {
        return null;
    }

    const redirectValue = _.values(redirectConfig)[0];

    // If redirect value is true, redirect to pathname
    if (redirectValue === true) {
        return pathname;
    }

    // Handle string redirects
    if (typeof redirectValue === 'string') {
        return redirectValue;
    }

    // Handle linkOut redirects
    if (redirectValue?.linkOut?.redirectPage) {
        const { trigger, redirectPage } = redirectValue.linkOut;
        if (trigger) {
            sessionStorage.setItem('linkOutTrigger', trigger);
        }
        return redirectPage;
    }

    return null;
};

export const redirectToPage = (location) => {
    // Für c24 Kundenbereich
    if (sessionStorage.getItem('redirect_page')) {
        window.location.replace(`#${sessionStorage.getItem('redirect_page')}`);
        return true;
    }

    const redirectOption = location.state?.from?.pathname || '/';
    const redirectTarget = checkAndPerformRedirect(redirectOption);

    // If redirect target is found, redirect to it
    if (redirectTarget) {
        window.location.href = '#' + redirectTarget;
        return true;
    }

    // Default fallback to root
    if (window.location.hash === '#/login' || window.location.pathname.includes('/login')) {
        window.location.href = '#/';
        return true;
    }

    return false;
};

export function affiliate_checkIsAllowToBookService(service) {
    let checkArr = [];

    if (window.$affiliate) {
        if (window.$affiliateServices && window.$affiliateServices.includes(service)) {
            checkArr.push(service);
        }
    }

    return checkArr;
}

export function checkTripEnded() {
    const travelEnd = storage.get('bookingData')?.travelEnd;
    if (!travelEnd) {
        return false;
    }
    const end = new Date(travelEnd);
    end.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return end < today;
}

export function checkIsAlreadyBooked() {
    let checkArr = [];
    let railAndFlyDirections = [];

    if (storage.get('bookingData') !== null) {
        let bookingData = storage.get('bookingData');

        function logic(value, key, frontend = false) {
            if (key === 'railAndFly') {
                _.forEach(value, function (railAndFlyValue) {
                    if (frontend) {
                        if (railAndFlyValue.data?.direction !== undefined) {
                            railAndFlyDirections.push(railAndFlyValue.data.direction);
                        }
                    } else {
                        railAndFlyDirections.push(railAndFlyValue.direction);
                    }
                });
            }

            if (key === 'transfer' && bookingData.data.serviceInformation[key]?.state === 'OK') {
                checkArr.push('transferCruise');
            }
        }

        // booked service : IBE
        if (bookingData) {
            if (bookingData.data) {
                if (bookingData.data.serviceInformation) {
                    _.forEach(bookingData.data.serviceInformation, function (value, key) {
                        logic(value, key);
                        checkArr.push(key);
                    });
                }

                /** seatReservation :: all possible seats booked **/
                if (bookingData.data?.isAllPossibleSeatsBooked) {
                    checkArr.push('seatReservation');
                }
            }

            // booked service : frontend
            if (bookingData.bookedService !== null) {
                _.forEach(storage.get('bookingData').bookedService, function (value, key) {
                    logic(value, key, true);
                    checkArr.push(key);
                });
            }
        }

        if (checkArr.length > 0) {
            if (!(
                railAndFlyDirections.includes('both') ||
                (railAndFlyDirections.includes('inbound') && railAndFlyDirections.includes('outbound'))
            )) {
                let railAndFlyElement = checkArr.indexOf('railAndFly');
                if (railAndFlyElement > -1) {
                    checkArr.splice(railAndFlyElement, 1);
                }
            }
        }
    }

    return checkArr;
}

export function checkIsAllowToBookService(service) {
    let checkArr = [];
    if (storage.get('bookingData') !== null) {
        const { data } = storage.get('bookingData');
        checkArr = checkIsAlreadyBooked();

        // global : affiliate → allowed services
        if (window.$affiliate) {
            _.forEach(!affiliate_checkIsAllowToBookService(service), function (value) {
                checkArr.push(value);
            });
        }

        // global : deactivate extras
        if (!checkArr.includes(service) && window.$deactivateExtras.includes(service)) {
            checkArr.push(service);
        }

        // global : deactivate services
        if (window.deactivateServices.includes(service)) {
            checkArr.push(service);
        }

        // check if apis can be set
        if (service === 'Apis' && tripStartCountdown(data.searchParams.depDate) < 3) {
            checkArr.push(service);
        }
    }

    if (checkArr.length > 0) {
        if (checkArr.includes(service)) {
            setTimeout(function () {
                window.location.href = '#/';
                return false;
            }, 0);
        }
    }
    return true;
}
